import * as Yup from "yup";

import { MAIL_REGEX } from "../Patterns";

/** Lowercase public / consumer domains that are not accepted as company email. */
export const BLOCKED_EMAIL_DOMAINS = Object.freeze([
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "icloud.com",
  "live.com",
  "msn.com",
  "aol.com",
]);

const BLOCKED_SET = new Set(
  BLOCKED_EMAIL_DOMAINS.map((d) => d.toLowerCase())
);

const MIN_DOMAIN_LENGTH = 3;
const MAX_DOMAIN_LENGTH = 253;

/** @param {string} email */
function getEmailDomain(email) {
  const trimmed = email.trim();
  const at = trimmed.lastIndexOf("@");
  if (at < 0 || at === trimmed.length - 1) {
    return null;
  }
  const domain = trimmed.slice(at + 1).trim().toLowerCase();
  return domain.length > 0 ? domain : null;
}

/**
 * @param {string} email
 * @returns {boolean}
 */
export function isBusinessEmail(email) {
  const domain = getEmailDomain(email);
  if (!domain) {
    return false;
  }
  if (BLOCKED_SET.has(domain)) {
    return false;
  }
  if (!domain.includes(".")) {
    return false;
  }
  if (
    domain.length < MIN_DOMAIN_LENGTH ||
    domain.length > MAX_DOMAIN_LENGTH
  ) {
    return false;
  }
  return true;
}

/**
 * i18n key under `inputsValidations` — keep in sync with locale files.
 */
export const BUSINESS_EMAIL_YUP_MESSAGE_KEY = "businessEmailPublicProvider";

export const businessEmailValidation = Yup.string()
  .trim()
  .required("emailRequired")
  .matches(MAIL_REGEX, "validEmailFormat")
  .test(
    "business-email",
    BUSINESS_EMAIL_YUP_MESSAGE_KEY,
    (value) => value == null || value === "" || isBusinessEmail(value)
  );
